import styled from 'styled-components';

const offsetTop = 1.8;
const offsetMiddle = offsetTop + 0.6;
const offsetBottom = offsetTop + 1.2;

export const Container = styled.a`
  position: relative;
  width: 4.2rem;
  height: 5.2rem;
  cursor: pointer;
  display: inline-block;
`;

// TODO: (RT-552) Ideally, we'd use a base component that LayerOne, LayerTwo, LayerThree and LayerFour extend, however doing so generates rendering issues.
// These components will use redundant code until a bettter solution is found.
export const LayerOne = styled.span<{ aligned: string; isActive: boolean; isWhite: boolean }>`
  position: absolute;
  display: block;
  left: ${props => (props.aligned === 'left' ? props.theme.space.none : props.theme.space['2.0'])};
  height: 0.3rem;
  width: 2rem;
  padding: ${props => props.theme.space.none};
  margin: ${props => props.theme.space.none};
  border-radius: ${props => props.theme.radii.small};
  transition: ${props => props.theme.animationSpeeds.fast} ease-in-out;
  background: ${props => (props.isWhite ? props.theme.colors.white : props.theme.colors.capsuleBlue50)};
  top: ${offsetTop}rem;
  opacity: ${props => (props.isActive ? props.theme.opacities.none : props.theme.opacities.full)};
`;

export const LayerTwo = styled.span<{ aligned: string; isActive: boolean; isWhite: boolean }>`
  position: absolute;
  display: block;
  left: ${props => (props.aligned === 'left' ? props.theme.space.none : props.theme.space['2.0'])};
  height: 0.3rem;
  width: 2rem;
  padding: ${props => props.theme.space.none};
  margin: ${props => props.theme.space.none};
  border-radius: ${props => props.theme.radii.small};
  opacity: ${props => props.theme.opacities.full};
  transition: ${props => props.theme.animationSpeeds.fast} ease-in-out;
  background: ${props => (props.isWhite ? props.theme.colors.white : props.theme.colors.capsuleBlue50)};
  top: ${offsetMiddle}rem;
  transform: ${props => (props.isActive ? 'rotate(45deg)' : '')};
`;

export const LayerThree = styled.span<{ aligned: string; isActive: boolean; isWhite: boolean }>`
  position: absolute;
  display: block;
  left: ${props => (props.aligned === 'left' ? props.theme.space.none : props.theme.space['2.0'])};
  height: 0.3rem;
  width: 2rem;
  padding: ${props => props.theme.space.none};
  margin: ${props => props.theme.space.none};
  border-radius: ${props => props.theme.radii.small};
  opacity: ${props => props.theme.opacities.full};
  transition: ${props => props.theme.animationSpeeds.fast} ease-in-out;
  background: ${props => (props.isWhite ? props.theme.colors.white : props.theme.colors.capsuleBlue50)};
  top: ${offsetMiddle}rem;
  transform: ${props => (props.isActive ? 'rotate(-45deg)' : '')};
`;

export const LayerFour = styled.span<{ aligned: string; isActive: boolean; isWhite: boolean }>`
  position: absolute;
  display: block;
  left: ${props => (props.aligned === 'left' ? props.theme.space.none : props.theme.space['2.0'])};
  height: 0.3rem;
  width: 2rem;
  padding: ${props => props.theme.space.none};
  margin: ${props => props.theme.space.none};
  border-radius: ${props => props.theme.radii.small};
  transition: ${props => props.theme.animationSpeeds.fast} ease-in-out;
  background: ${props => (props.isWhite ? props.theme.colors.white : props.theme.colors.capsuleBlue50)};
  top: ${offsetBottom}rem;
  opacity: ${props => (props.isActive ? props.theme.opacities.none : props.theme.opacities.full)};
`;
